app.UserDetails =
    (function () {
        var details = {
            Init: function () {
                $("[data-role='copy-link']").on("click keyup",
                    function () {
                        $(this).closest(".input-group").find("input[type='text']").select();
                        document.execCommand("copy");
                        toastr.success("Successfully copied to clipboard.");
                    });

                var data = { id: $('input[data-reset-filter]').data('reset-filter') };

                $('input[data-reset-filter]').on("click", function () {
                    //submit to endpoint
                    $.post("/Admin/User/ResetPersistentGridFilters", data,
                        function () {

                            toastr.success("You successfully reset all of the user's remembered filters.", "Success");
                        })
                        .fail(function () {
                            app.ApplicantSearch.ResetDistrictHideCheckboxes();
                            toastr.error("There was an error and the update was not made.", "Error");

                        });
                });
                $(document).on("component-bind-edit-mode-complete", function (e, component) {
                    $("input[name='RoleIds']").on("change", function () {
                        var checkboxList = $("input[name='RoleIds']");
                        var mostRecentSelection = $(this);
                        var mostRecentSelectionDisplayName = mostRecentSelection.parent().text().trim(); // Get the display name of the most recent selection

                        checkboxList.filter(":checked").each(function () {
                            if ($(this).val() === mostRecentSelection.val()) {
                                return;
                            }

                            var selectedOptionDisplayName = $(this).parent().text().trim(); // Get the display name of the selected option

                            // Check if the most recent selection has the display name "Admin" and the selected option has the display name "SuperAdmin"
                            if (mostRecentSelectionDisplayName === "Admin" && selectedOptionDisplayName === "SuperAdmin") {
                                $(this).prop("checked", false); // Uncheck the selected option
                            }

                            // Check if the most recent selection has the display name "SuperAdmin" and the selected option has the display name "Admin"
                            if (mostRecentSelectionDisplayName === "SuperAdmin" && selectedOptionDisplayName === "Admin") {
                                $(this).prop("checked", false); // Uncheck the selected option
                            }
                        });
                    });

                });
            }
        };
        return details;
    }()
    );
